import { render, staticRenderFns } from "./RefereeDetails.vue?vue&type=template&id=2a512a6e&scoped=true&"
import script from "./RefereeDetails.vue?vue&type=script&lang=js&"
export * from "./RefereeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RefereeDetails.vue?vue&type=style&index=0&id=2a512a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a512a6e",
  null
  
)

export default component.exports